import {
  BOOK_DATA,
  CREATE_BOOK_LOADER,
  CREATE_VOLUME_LOADER,
  CREATE_VOLUME_LOADER_NUMBER,
  DELETE_BOOK_LOADER,
  DELETE_BOOK_VOLUMES_LOADER,
  GET_BOOK_VOLUMES_DATA,
  GET_BOOK_VOLUMES_LOADER,
  GET_SINGLE_BOOK_DATA,
} from '../action/Book';

const initialState = {
  createBookLoader: false,
  bookData: [],
  deleteBookLoader: false,
  getSingleBook: false,
  volumesData: false,
  deleteBolumesDataLoader: false,
  getAllSearchPost: false,
  createVolumeLoaderNumber: false,
};

const ContentReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_BOOK_LOADER:
      return {
        ...state,
        createBookLoader: action.payload,
      };
    case BOOK_DATA:
      return {
        ...state,
        bookData: action.payload,
      };

    case DELETE_BOOK_LOADER:
      return {
        ...state,
        deleteBookLoader: action.payload,
      };
    case GET_SINGLE_BOOK_DATA:
      return {
        ...state,
        getSingleBook: action.payload,
      };
    case GET_BOOK_VOLUMES_DATA:
      return {
        ...state,
        volumesData: action.payload,
      };
    case DELETE_BOOK_VOLUMES_LOADER:
      return {
        ...state,
        deleteBolumesDataLoader: action.payload,
      };
    case CREATE_VOLUME_LOADER:
      return {
        ...state,
        getAllSearchPost: action.payload,
      };
    case CREATE_VOLUME_LOADER_NUMBER:
      return {
        ...state,
        createVolumeLoaderNumber: action.payload,
      };

    default:
      return {
        ...state,
      };
  }
};
export default ContentReducer;
